/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

class Bell extends PureComponent {
  render = () => (
    <SvgIcon viewBox="0 0 150 150" {...this.props}>
      <defs>
        <path
          d="M0 .9817c0 4.3664 3.5833 9.4895 7.9583 9.4895h3.1834c4.375 0 7.9583-5.1231 7.9583-9.4895H0z"
          id="a"
        />

        <path
          d="M77.3917 69.745c1.3171-.0045 2.3863-1.0642 2.4-2.3787v-3.8257a5.9083 5.9083 0 00-1.825-3.9422S62.3 46.2914 61.125 25.1418C59.7083-.1996 46.7333.8317 40 .8317S20.2917-.1996 18.875 25.125C17.7 46.2998 2.0333 59.5818 2.0333 59.5818a5.9 5.9 0 00-1.825 3.9422v3.8423c.0046 1.321 1.0764 2.3907 2.4 2.3953h74.7834v-.0166z"
          id="c"
        />

        <filter
          filterUnits="objectBoundingBox"
          height="135%"
          id="e"
          width="135%"
          x="-17.5%"
          y="-12.5%"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />

          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />

          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />

          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
        </filter>

        <circle cx="126" cy="68" id="f" r="20" />
      </defs>

      <g fill="none" fillRule="evenodd">
        <circle cx="84" cy="84" r="62" stroke="#F8EDF9" strokeOpacity=".3589" strokeWidth="4" />

        <circle cx="84" cy="84" r="82" stroke="#F8EDF9" strokeOpacity=".2113" strokeWidth="4" />

        <circle cx="84" cy="84" r="42" stroke="#F8EDF9" strokeOpacity=".5277" strokeWidth="4" />

        <g transform="rotate(15 -88.915 236.7023)">
          <g transform="translate(30.45 73.5288)">
            <mask fill="#fff" id="b">
              <use href="#a" />
            </mask>

            <use fill="#40B6F5" fillRule="nonzero" href="#a" />

            <path d="M9.5832 0h10v12h-10z" fill="#3AA7E1" mask="url(#b)" />
          </g>

          <mask fill="#fff" id="d">
            <use href="#c" />
          </mask>

          <use fill="#40B6F5" fillRule="nonzero" href="#c" />

          <path d="M40-2.495h43.3333v74.8515H40z" fill="#3AA7E1" mask="url(#d)" />
        </g>

        <g fillRule="nonzero">
          <use fill="#000" filter="url(#e)" href="#f" />

          <circle
            cx="126"
            cy="68"
            fill="#E30C79"
            fillRule="evenodd"
            r="18"
            stroke="#FFF"
            // @ts-expect-error ts-migrate(2322) FIXME: Type '"square"' is not assignable to type '"inheri... Remove this comment to see the full error message
            strokeLinejoin="square"
            strokeWidth="4"
          />
        </g>

        <path
          d="M128.2667 74V61.02h-2.7c-.22 1.32-1.6 2.42-3.54 2.44v2.1h3.1V74h3.14z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </SvgIcon>
  );
}

export default Bell;
